import { useEffect, useRef } from "react"; // ضفنا useRef
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.css";
import Hook = flatpickr.Options.Hook;
import DateOption = flatpickr.Options.DateOption;
import { Calendar } from "lucide-react";

type PropsType = {
    id: string;
    mode?: "single" | "multiple" | "range" | "time";
    onChange?: Hook | Hook[];
    defaultDate?: DateOption;
    label?: string;
    placeholder?: string;
    success?: boolean;
    error?: boolean;
    hint?: string;
    enableTime?: boolean;
};

export default function DatePicker({
    id,
    mode,
    onChange,
    label,
    defaultDate,
    placeholder,
    success = false,
    error = false,
    hint,
    enableTime = false,
}: PropsType) {
    const fpRef = useRef<flatpickr.Instance | null>(null);

    useEffect(() => {
        fpRef.current = flatpickr(`#${id}`, {
            mode: mode || "single",
            static: true,
            monthSelectorType: "static",
            dateFormat: enableTime ? "Y-m-d H:i:S" : "Y-m-d",
            enableTime: enableTime,
            time_24hr: true,
            defaultDate,
            onChange,
            allowInput: true
        }) as flatpickr.Instance;

        return () => {
            if (fpRef.current) {
                fpRef.current.destroy();
            }
        };
    }, [mode, id, enableTime]);

    useEffect(() => {
        if (fpRef.current) {
            fpRef.current.setDate(defaultDate || "", true);
        }
    }, [defaultDate]);

    useEffect(() => {
        if (fpRef.current && onChange) {
            fpRef.current.set("onChange", onChange);
        }
    }, [onChange]);

    return (
        <div>
            {label && <label className="block text-xs font-semibold text-slate-900 mb-1.5 ml-1" htmlFor={id}>{label}</label>}

            <div className="relative">
                <input
                    id={id}
                    placeholder={placeholder}
                    className={`px-10 h-11 w-full rounded-lg border  ${error ? "border-error-500 focus:border-error-300" : "border-gray-300 focus:border-brand-300"} appearance-none px-4 py-2.5 text-sm shadow-theme-xs placeholder:text-gray-400 focus:outline-hidden focus:ring-3  dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30  bg-transparent text-gray-800 border-gray-300 focus:border-brand-300 focus:ring-brand-500/20 dark:border-gray-700  dark:focus:border-brand-800`}
                />
                <span className="absolute text-gray-500 -translate-y-1/2 pointer-events-none right-3 top-1/2 dark:text-gray-400">
                    <Calendar className="size-6" />
                </span>
            </div>
            {hint && (
                <p
                    className={`mt-1.5 text-xs ${error
                        ? "text-error-500"
                        : success
                            ? "text-success-500"
                            : "text-gray-500"
                        }`}
                >
                    {hint}
                </p>
            )}
        </div>
    );
}   